import {Route} from '@angular/router';
import {AuthGuard} from '../../auth/guards/auth.guard';

export const profileRoute: Route = {
    path: 'perfil',
    canLoad: [AuthGuard],
    loadChildren: () => import('./profile.module').then(m => m.ProfileModule),
};
